<template>
    <div class="c-community__title">
        <h5>{{ community.name }}</h5>
        <div class="c-community__info">
            <img :src="$cdn('/img/icons/icon-members.svg')" alt="Community Members" width="24" height="16">
            <router-link :to="'/' + $root.community.url + '/members'" v-slot="{ href, route, navigate, isActive, isExactActive }" custom>
                <p><a :href="href" @click="navigate">Members {{stats.members}}</a></p>
            </router-link>
        </div>

        <div class="c-community__info">
            <img :src="$cdn('/img/icons/icon-likes.svg')" alt="Community Likes" width="17" height="16">
            <p>Likes {{stats.likes}}</p>
        </div>

        <div class="c-community__info">
            <img :src="$cdn('/img/icons/icon-views.svg')" alt="Community Views" width="18" height="14">
            <p>Views {{stats.views}}</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            community: this.$root.community,
            stats: this.$simpleStore.stats,
            es: null
        }
    },
    methods: {
        getStats() {
            this.es = new EventSource('/sse-cs/' + this.community.id);
            let countEvents = 0;
            this.es.addEventListener('json', (event) => {
                let type = event.type;
                let data = JSON.parse(event.data);
                this.$simpleStore.setStatsMembers(data.members);
                this.$simpleStore.setStatsLikes(data.likes);
                this.$simpleStore.setStatsViews(data.views);
                countEvents++;
                if (countEvents >= 100) {
                    this.es.close();
                }
            }, false);
        }
    },
    mounted() {
        // initialise stats before polling starts
        this.$simpleStore.setStatsMembers(this.community.members);
        this.$simpleStore.setStatsLikes(this.community.likes);
        this.$simpleStore.setStatsViews(this.community.views);
        this.getStats();
        window.addEventListener('pagehide', () => {
            this.es.close();
        });
    }
}
</script>
